export type CardPool = "collection" | "all";

type PreferenceStorage = Pick<Storage, "getItem" | "setItem">;

function preferenceKey(owner: string, deckId: string): string {
  return `mtg-agent:deck-card-pool:${encodeURIComponent(owner)}:${encodeURIComponent(deckId)}`;
}

export function readDeckCardPoolPreference(
  owner: string,
  deckId: string,
  hasCollection: boolean,
  storage?: PreferenceStorage,
): CardPool {
  if (!hasCollection) return "all";
  try {
    const value = (storage ?? window.localStorage).getItem(preferenceKey(owner, deckId));
    if (value === "collection" || value === "all") return value;
  } catch {
    // Storage may be unavailable in private browsing or outside a browser.
  }
  return "collection";
}

export function writeDeckCardPoolPreference(
  owner: string,
  deckId: string,
  pool: CardPool,
  storage?: PreferenceStorage,
): void {
  try {
    (storage ?? window.localStorage).setItem(preferenceKey(owner, deckId), pool);
  } catch {
    // The current selection still works when persistence is unavailable.
  }
}
